// extracted by mini-css-extract-plugin
module.exports = {"root":"Select-module__root--2r7wy","inactive":"Select-module__inactive--3tLYm Select-module__root--2r7wy","inputLabel":"Select-module__inputLabel--2PD1t"};